module.exports = __webpack_public_path__ + "img/erweima.2901e8e2.jpg";